<template>
  <div class="queueListsPage">
    <Row style="overflow: hidden;font-size: 15px;">
      <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3"><h3>预约时间</h3></Col>
      <Col :lg="6" :xl="6" :xxl="6" :md="6" :xs="6"><h3>姓名</h3></Col>
      <Col :lg="8" :xl="11" :xxl="11" :md="10" :xs="8"><h3>检查部位</h3></Col>
      <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3"><h3>检查状态</h3></Col>
      <Col v-if="tableType === 'callNum'" :lg="4" :xl="2" :xxl="2" :md="2" :xs="2"><h3>匹配状态</h3></Col>
      <Col v-if="tableType === 'queue'" :lg="4" :xl="2" :xxl="2" :md="2" :xs="3"><h3>报告状态</h3></Col>
    </Row>
    <div class="listContent" ref="queueList">
      <List :header="dataList[0].date" v-if="dataList[0] && dataList[0].list" class="nowDateList" itemLayout="vertical" :dataSource="dataList[0].list">
        <ListItem slot="renderItem" slot-scope="item" :class="item.queueUpItemList ? 'notPadding' : ''">
          <Row>
            <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-if="!item.queueUpItemList">{{item.timer}}</Col>
          </Row>
          <div v-if="item.showLine" class="curDateLine" ref="curDate"></div>
          <div v-else></div>
          <List :split="false" v-if="item.queueUpItemList" :dataSource="item.queueUpItemList">
            <ListItem slot="renderItem" slot-scope="val, index" :class="{'wrapActive': item.active && curIndex === val.checkOrderId }" @click.native="selectItem(val, item)">
              <Row :class="{'active': item.active && curIndex === val.checkOrderId }">
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" class="time" v-if="index === 0">{{item.timer}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else></Col>
                <Col :lg="6" :xl="6" :xxl="6" :md="6" :xs="6">
                  <span>{{val.realName}}</span>
                  <span v-if="val.emergency">（急）</span>
                  <img src="https://webimage.tongxinyiliao.com/ris/images/man.png" style="margin-left:10px;padding-bottom: 3px;" v-if="val.gender && val.gender.toString() === '1'" />
                  <img src="https://webimage.tongxinyiliao.com/ris/images/woman.png" style="margin-left:10px;padding-bottom: 3px;" v-if="val.gender && val.gender.toString() === '2'" />
                  <img src="https://webimage.tongxinyiliao.com/ris/images/printer.png" style="margin-left:10px;padding-bottom: 3px;" class="printer" v-if="val.isPrinted" />
                  <img src="https://webimage.tongxinyiliao.com/ris/images/printer.png" style="margin-left:10px;padding-bottom: 3px;"  v-if="val.isPrinted === false" />
                  <img src="https://webimage.tongxinyiliao.com/ris/images/views.png" style="margin-left:10px;padding-bottom: 3px;width:16px;" v-if="val.matchedStatus" @click="filmView(val)"/>
                  <img src="https://webimage.tongxinyiliao.com/ris/images/images.png" style="margin-left:10px;padding-bottom: 3px;width:16px;" v-if="val.bindCount>0" @click="showImagesRecord(val)"/>
                  <img src="https://webimage.tongxinyiliao.com/ris/images/money.png" style="margin-left:10px;padding-bottom: 3px;width:16px;" v-if="tableType === 'queue' && (val.paymentStatus===10 || val.paymentStatus===1)" @click="showPayCode(val)"/>
                </Col>
                <Col :lg="8" :xl="11" :xxl="11" :md="10" :xs="8">
                  <div v-for="(bodyItem, index) in val.bodyItems" :key="index">{{bodyItem.alias || bodyItem.name}}{{bodyItem.count > 1 ? `*${bodyItem.count}` : ''}}</div>
                </Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-if="getStatusText(val.status) === '等待叫号'" :style="{'color': (item.active && curIndex === val.checkOrderId ? '#fff' : '#1890ff')}">{{getStatusText(val.status)}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else-if="getStatusText(val.status) === '扫描中'" :style="{'color': (item.active && curIndex === val.checkOrderId ? '#fff' : '#03c392')}">{{getStatusText(val.status)}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else-if="getStatusText(val.status) === '已扫描'" :style="{'color': (item.active && curIndex === val.checkOrderId ? '#fff' : '#333')}">{{getStatusText(val.status)}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else-if="getStatusText(val.status) === '预约完成'" :style="{'color': (item.active && curIndex === val.checkOrderId ? '#fff' : '#f9cd97')}">{{getStatusText(val.status)}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else>{{getStatusText(val.status)}}</Col>
                <Col v-if="tableType === 'callNum'" :lg="4" :xl="2" :xxl="2" :md="2" :xs="2">
                  {{(val.matchedStatus ? '已匹配' : '')}}
                </Col>
                <Col v-if="tableType === 'queue'" :lg="4" :xl="2" :xxl="2" :md="2" :xs="3">
                  {{val.reportStatus|reportStatus}}
                </Col>
              </Row>
            </ListItem>
          </List>
        </ListItem>
      </List>
      <List :header="dataList[1].date" v-if="dataList[1] && dataList[1].list" class="nextDateList" itemLayout="vertical" :dataSource="dataList[1].list">
        <ListItem slot="renderItem" slot-scope="item" :class="item.queueUpItemList ? 'notPadding' : ''">
          <Row>
            <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-if="!item.queueUpItemList">{{item.timer}}</Col>
          </Row>
          <div v-if="item.showLine" class="curDateLine" ref="curDate"></div>
          <div v-else></div>
          <List :split="false" v-if="item.queueUpItemList" :dataSource="item.queueUpItemList">
            <ListItem slot="renderItem" slot-scope="val, index" :class="{'wrapActive': item.active && curIndex === val.checkOrderId }" @click.native="selectItem(val, item)">
              <Row :class="{'active': item.active && curIndex === val.checkOrderId }">
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" class="time" v-if="index === 0">{{item.timer}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else></Col>
                <Col :lg="6" :xl="6" :xxl="6" :md="6" :xs="6">
                  <span>{{val.realName}}</span>
                  <span v-if="val.emergency">（急）</span>
                  <img src="https://webimage.tongxinyiliao.com/ris/images/man.png" style="margin-left:10px;padding-bottom: 3px;" v-if="val.gender && val.gender.toString() === '1'" />
                  <img src="https://webimage.tongxinyiliao.com/ris/images/woman.png" style="margin-left:10px;padding-bottom: 3px;" v-if="val.gender && val.gender.toString() === '2'" />
                  <img src="https://webimage.tongxinyiliao.com/ris/images/printer.png" style="margin-left:10px;padding-bottom: 3px;" class="printer" v-if="val.isPrinted" />
                  <img src="https://webimage.tongxinyiliao.com/ris/images/printer.png" style="margin-left:10px;padding-bottom: 3px;"  v-if="val.isPrinted === false" />
                  <img src="https://webimage.tongxinyiliao.com/ris/images/views.png" style="margin-left:10px;padding-bottom: 3px;width:16px;" v-if="val.matchedStatus" @click="filmView(val)"/>
                  <img src="https://webimage.tongxinyiliao.com/ris/images/images.png" style="margin-left:10px;padding-bottom: 3px;width:16px;" v-if="val.bindCount>0" @click="showImagesRecord(val)"/>
                  <img src="https://webimage.tongxinyiliao.com/ris/images/money.png" style="margin-left:10px;padding-bottom: 3px;width:16px;" v-if="tableType === 'queue' && (val.paymentStatus===10 || val.paymentStatus===1)" @click="showPayCode(val)"/>
                </Col>
                <Col :lg="8" :xl="11" :xxl="11" :md="10" :xs="8">
                  <div v-for="(bodyItem, index) in val.bodyItems" :key="index">{{bodyItem.alias || bodyItem.name}}{{bodyItem.count > 1 ? `*${bodyItem.count}` : ''}}</div>
                </Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-if="getStatusText(val.status) === '等待叫号'" :style="{'color': (item.active && curIndex === val.checkOrderId ? '#fff' : '#1890ff')}">{{getStatusText(val.status)}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else-if="getStatusText(val.status) === '扫描中'" :style="{'color': (item.active && curIndex === val.checkOrderId ? '#fff' : '#03c392')}">{{getStatusText(val.status)}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else-if="getStatusText(val.status) === '已扫描'" :style="{'color': (item.active && curIndex === val.checkOrderId ? '#fff' : '#333')}">{{getStatusText(val.status)}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else-if="getStatusText(val.status) === '预约完成'" :style="{'color': (item.active && curIndex === val.checkOrderId ? '#fff' : '#f9cd97')}">{{getStatusText(val.status)}}</Col>
                <Col :lg="3" :xl="2" :xxl="2" :md="3" :xs="3" v-else>{{getStatusText(val.status)}}</Col>
                <Col v-if="tableType === 'callNum'" :lg="4" :xl="2" :xxl="2" :md="2" :xs="2">
                  {{(val.matchedStatus ? '已匹配' : '')}}
                </Col>
                <Col v-if="tableType === 'queue'" :lg="4" :xl="2" :xxl="2" :md="2" :xs="3">
                  {{val.reportStatus|reportStatus}}
                </Col>
              </Row>
            </ListItem>
          </List>
        </ListItem>
      </List>
    </div>
    <Modal v-model="imagesRecordFlag" title="影像操作记录" :width="960" :footer="null" :forceRender="false">
      <imagesRecord v-if="imagesRecordFlag" @closeImagesRecord="closeImagesRecord" :orderCheckId="orderCheckId"></imagesRecord>
    </Modal>
  </div>
</template>

<script>
import { scanningStatus, reportStatus } from '../../core/filter'
import { List, Row, Col, Modal } from 'ant-design-vue'
import { switchTimeFormat, getSession, setSession, toast } from '../../libs/utils'
import { WatchImageByWeasisOrOsrix } from '../../libs/mixin'
import imagesRecord from '../../components/imagesRecord'
import { makePayCode } from '../../api/onlineCheckin'

export default {
  components: {
    List,
    ListItem: List.Item,
    Row,
    Col,
    Modal,
    imagesRecord
  },
  props: {
    dataList: {
      type: Array,
      default: () => ([])
    },
    defaultDeviceId: {
      type: Number,
      default: 0
    }
  },
  mixins: [WatchImageByWeasisOrOsrix],
  data () {
    return {
      titleList: [],
      curIndex: null,
      timer: '',
      tableType: '',
      imagesRecordFlag: false,
      orderCheckId: 0
    }
  },
  methods: {
    reportStatus (num) {
      return reportStatus(num)
    },
    getStatusText (num) {
      return scanningStatus(num)
    },
    selectItem (record, item) {
      let top = this.$refs['queueList'].scrollTop.toString()
      setSession('scrollTop', top)
      item.active = true
      this.curIndex = record.checkOrderId
      this.$emit('selectTableItem', record)
      setSession('oldDeviceId', this.defaultDeviceId + this.$route.name)
    },
    // 截取时间转化为数字
    handelTime (time) {
      let newTime = time.toString().replace(':', '')
      return +newTime
    },
    // 判断当前时间与红线显示时间
    curDate () {
      let nowDate = switchTimeFormat(new Date(), 7)
      let time = nowDate.slice(0, 5).toString().replace(':', '')
      if (this.dataList && this.dataList[0] && this.dataList[0].list) {
        let interval = (this.handelTime(this.dataList[0].list[1].timer)) - (this.handelTime(this.dataList[0].list[0].timer))
        this.dataList[0] && this.dataList[0].list.forEach(val => {
          if ((+time - this.handelTime(val.timer)) >= 0 && (+time - this.handelTime(val.timer)) < interval) {
            val.showLine = true
          } else {
            val.showLine = false
          }
        })
      }
      if (this.dataList && this.dataList[1] && this.dataList[1].list) {
        let interval = (this.handelTime(this.dataList[0].list[1].timer)) - (this.handelTime(this.dataList[0].list[0].timer))
        this.dataList[1] && this.dataList[1].list.forEach(val => {
          if ((+time - this.handelTime(val.timer)) >= 0 && (+time - this.handelTime(val.timer)) < interval) {
            val.showLine = true
          } else {
            val.showLine = false
          }
        })
      }
    },
    // 自动滚动到红线
    autoScroll () {
      let line = this.$refs['curDate']
      if (line)
      {
        let height = document.body.clientHeight/2
        let top = line.getBoundingClientRect().top - height - 100
        this.$refs['queueList'].scrollTop = top
      }
    },
    // 滚动到当前选中项位置
    scrollCur () {
      let top = getSession('scrollTop', 'number')
      this.$refs['queueList'].scrollTop = top
    },
    // 在线阅片
    async filmView (params) {
      return this.openFilmView({filmNo: params.filmNo || ''})
    },
    // 影像操作记录
    showImagesRecord (val) {
      this.imagesRecordFlag = true
      this.orderCheckId = val.checkOrderId
    },
    closeImagesRecord () {
      this.imagesRecordFlag = false
    },
    // 未支付发送支付二维码
    async showPayCode (val) {
      let data = await makePayCode({ checkOrderId: val.checkOrderId })
      if (data) toast({ title: '提示', type: 'success', msg: '支付二维码生成成功' })
    },
  },
  created () {
    this.tableType = this.$route.name
    // 当前时间红线的定时器
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(() => {
        this.curDate()
      }, 60000)
    }
  },
  updated () {
    let oldDeviceId = getSession('oldDeviceId', 'string')
    if (oldDeviceId !== (this.defaultDeviceId + this.$route.name)) {
      this.autoScroll()
    } else {
      this.scrollCur()
    }
  },
  destroyed () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.queueListsPage{
  overflow: auto;
  .ant-row{
    text-align: center;
    h3{
      font-weight: 700;
    }
  }
  .ant-list.ant-list-vertical.ant-list-split{
    border-bottom: 1px solid #e8e8e8;
    .ant-list-header{
      text-align: center;
    }
    .notPadding{
      padding-top: 0;
      padding-bottom: 0;
    }
    .ant-spin-nested-loading{
      .ant-spin-container{
        .ant-list-item{
          .ant-list-item-content.ant-list-item-content-single{
            margin-bottom: 0;
            position: relative;
            .ant-list.ant-list-split{
              .ant-spin-nested-loading{
                .ant-spin-container{
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
  }
  .curDateLine{
    width: 100%;
    height: 1px;
    background-color: red;
    position: relative;
    top: -10px;
  }
  .ant-row{
    display: flex !important;
    align-items: center;
    width: 100%;
  }
  .active{
    color: #fff;
  }
  .wrapActive{
    background: rgba(0, 153, 255, 1);
    box-shadow: 0px 2px 10px #1173ce;
    border: none;
  }
  @media all and (max-width: 1090px) {
    .listContent{
      overflow-y: scroll;
      overflow-x: hidden;
      height: calc(100vh - 200px);
    }
  }
  @media all and (min-width: 1090px) {
    .listContent{
      overflow-y: scroll;
      overflow-x: hidden;
      height: calc(100vh - 170px);
    }
  }
  @keyframes printIcon {
    0%{
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
  .printer{
    animation: printIcon 0.5s linear 0.5s infinite alternate;
  }
}
</style>